__turbopack_context__.v({
  "Pretitle": "Statistic-module-scss-module__feSw6q__Pretitle",
  "Title": "Statistic-module-scss-module__feSw6q__Title",
});
